<template>
  <div style="width:100%;height:100%;">
    <resource-statistic-admin v-if="userType == 0"></resource-statistic-admin>
    <resource-statistic-teacher v-else></resource-statistic-teacher>
  </div>
</template>
<script>
import resourceStatisticAdmin from "./resourceStatisticAdmin.vue";
import resourceStatisticTeacher from "./resourceStatisticTeacher.vue";
import * as api from "../../../../../api/resourceStatistic";
export default {
  components: { resourceStatisticAdmin, resourceStatisticTeacher },
  data() {
    return {
      loading: false,
      // ------------------------------------
      userType : sessionStorage.getItem('userType'),
      teacherView: false, // 老师视角
    };
  },
  created() {
    // this.getUserInfo();
  },
  mounted() {
  },
  methods: {
    // ----------------------------
    getUserInfo() {
          // console.log(err);
    },
  },
};
</script>
<style lang="scss" scoped>
.resource_statistic_wrap {
  --fontSize: calc(100vw / 19.2);
  box-sizing: border-box;
  padding-bottom: 8px;
  overflow-y: scroll;

  .resource_statistic_header {
    .header_group {
      font-size: 14px;
      .item {
        padding-right: 10px;
        .el-select {
          width: 120px;
        }
        .el-date-editor--daterange.el-input__inner {
          width: 246px;
        }
      }
    }
  }

  .product_section {
    background: #fff;
    padding: 10px 20px 20px;
    margin-top: 18px;

    .product_section_header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header_left {
        display: flex;
        align-items: center;

        .product_title {
          padding-right: 10px;
          margin-right: 10px;
          font-size: 18px;
          // font-weight: 600;
          border-right: 1px solid #ccc;
        }

        .el-button--text {
          font-weight: 600;
        }
      }

      .header_right {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 14px;
        color: rgba(166, 166, 166, 1);
      }
    }
    .product_section_list {
      display: flex;
      justify-content: space-between;

      .product_tiem {
        display: flex;
        flex: 1;
        border-radius: 16px;
        background: rgba(239, 249, 255, 0.48); // tod  0.48
        border: 1px solid rgba(233, 247, 255, 1);
        padding: 18px;
        margin-right: 30px;

        .product_left {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          background: rgba(87, 193, 255, 0.1);
          border-radius: 20px;

          .iconMin {
            width: 50%;
            height: 50%;
            background-size: 100% 100%;
          }
        }
        .product_right {
          display: flex;
          flex-flow: column;
          justify-content: center;
          padding-left: 12px;
          font-size: 14px;
          color: rgba(166, 166, 166, 1);

          .product_count {
            padding-bottom: 5px;
            font-size: 22px;
            color: #000;
          }
        }
      }
    }
  }

  .type_section {
    display: flex;
    margin-top: 28px;

    .type_section_list {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .type_tiem {
        display: flex;
        min-width: 40%;
        flex: 1;
        border-radius: 16px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(255, 255, 255, 1);
        box-shadow: -4px -4px 10px 0px rgba(255, 255, 255, 0.8),
          4px 4px 10px 0px rgba(222, 221, 227, 1);
        padding: 18px;
        justify-content: space-around;
        margin: 0 10px 10px 0;

        .type_right {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 93px;
          height: 93px;
          opacity: 1;
          border-radius: 30px;
          background: linear-gradient(
            180deg,
            rgba(243, 245, 247, 1) 0%,
            rgba(243, 245, 247, 1) 9.91%,
            rgba(254, 254, 255, 1) 100%
          );
          border: 1px solid rgba(255, 255, 255, 1);
          box-shadow: -4px -4px 10px 0px rgba(255, 255, 255, 0.8),
            4px 4px 10px 0px rgba(222, 221, 227, 1);

          .iconMin {
            width: 50%;
            height: 50%;
            background-size: 100% 100%;
          }
        }
        .type_left {
          display: flex;
          flex-flow: column;
          justify-content: center;
          padding-left: 12px;
          font-size: 14px;
          color: #000;

          .type_count {
            padding-bottom: 5px;
            font-size: 22px;
            font-weight: 700;

            .unit {
              font-size: 12px;
            }
          }
        }
      }
    }

    .echarts_item {
      flex: auto;
      border-radius: 4px;
      background: #fff;
      margin-right: 20px;

      // &.item1 {
      //   flex: auto
      // }
      // &.item2 {
      //   flex: auto
      // }
    }
  }

  .aphorism {
    height: calc(0.73 * var(--fontSize));
    margin-top: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/resourceStatistic/resourceStatistic.vue